
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'Skeleton',
    components: {},
})
export default class Skeleton extends Vue {
    private width: string = '100%';
    private height: string = '100%';

    public getStyle(obj: any, attr: string): number {
        if (obj.currentStyle) {
            return +obj.currentStyle[attr].replace('px', '');
        } else {
            return +(document.defaultView as any).getComputedStyle(obj, null)[attr].replace('px', '');
        }
    }

    public resize() {
        const p = this.$el.parentNode as HTMLElement;
        let width;
        let height;
        if (p) {
            width = p.clientWidth
                - this.getStyle(p, 'paddingLeft')
                - this.getStyle(p, 'paddingRight');
            this.width = width + 'px';
            height = p.clientHeight
                - this.getStyle(p, 'paddingTop')
                - this.getStyle(p, 'paddingBottom');
            this.height = height + 'px';
        }
    }

    private mounted() {
        this.resize();
        window.addEventListener('resize', this.resize);
    }

    private beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }
}
